import React, { useState } from 'react';
import { Alert, Button, Container } from 'reactstrap';
import { unwrapPayload } from '../../utilities';
import { WorkerHistorySection } from './WorkerHistorySection';

type SynchronizationSectionProperties =
{
    settings: any | null
    markVisibleProductsDirty: (values: any) => Promise<any>
    searchWorkerHistory: (values: any) => Promise<any>
}

function SynchronizationSection
(
    {
        settings,
        markVisibleProductsDirty,
        searchWorkerHistory
    }
    : SynchronizationSectionProperties
)
{
    const [lastError, setLastError] = useState<string | null>(null);
    const [queueResult, setQueueResult] = useState<any | null>(null);
    const [isQueueingVisibleProducts, setIsQueueingVisibleProducts] = useState(false);

    const queueVisibleProducts = async () =>
    {
        setLastError(null);
        setQueueResult(null);
        setIsQueueingVisibleProducts(true);

        try
        {
            const result = await markVisibleProductsDirty({ reason: 'ManualVisibleProductsRefresh' });
            setQueueResult(unwrapPayload(result));
        }
        catch (error: any)
        {
            setLastError(error?.message ?? 'Ponowne sprawdzenie produktów zakończyło się błędem.');
        }
        finally
        {
            setIsQueueingVisibleProducts(false);
        }
    };

    return (
        <Container fluid>
            {lastError && <Alert color="danger">{lastError}</Alert>}

            <section>
                <div className="d-flex flex-wrap justify-content-end mb-4">
                    <p className="text-muted mb-3">
                        Wymusza ponowną ocenę widocznych produktów dla aktywnych profili eksportu.
                        Produkty bez zmian nie zostaną ponownie wysłane do Google Merchant.
                    </p>

                    <Button
                        type="button"
                        color="secondary"
                        className="mb-2"
                        disabled={isQueueingVisibleProducts}
                        onClick={queueVisibleProducts}
                    >
                        Sprawdź ponownie widoczne produkty
                    </Button>
                    <p className="text-muted mb-3">
                        Oznacza wszystkie widoczne produkty sklepu jako wymagające ponownego sprawdzenia dla aktywnych profili eksportu.
                        Produkty bez zmian nie zostaną ponownie wysłane.
                    </p>
                </div>
            </section>

            {queueResult && (
                <Alert color={queueResult.success ? 'success' : 'warning'} className="mt-3">
                    {queueResult.message}
                </Alert>
            )}

            <WorkerHistorySection searchWorkerHistory={searchWorkerHistory} />
        </Container>
    );
}

export default SynchronizationSection;
